import { fetchWithTimeout } from './fetchWithTimeout';
import { UserGroup } from './user-group';

export type MenuConfig = {
    menuConfigId?: string;
    id?: string;
    parentId?: string;
    descr?: string;
    navigateTo?: string;
    iconValue?: string;
    enable?: 'Y' | 'N';
    createBy?: string;
    createDate?: Date;
    updateBy?: string;
    updateDate?: Date;
    userGroups?: UserGroup[];
};

type CreateRequestData = MenuConfig & {};

type CreateResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: MenuConfig;
};

function create(data: CreateRequestData) {
    return fetchWithTimeout('menu-config/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: CreateResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type CreateBulkResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: MenuConfig[];
};

function createBulk(data: CreateRequestData[]) {
    return fetchWithTimeout('menu-config/createBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: CreateBulkResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type GetRequestData = MenuConfig & {
    select?: (keyof MenuConfig)[];
    relations?: {
        [key in keyof Pick<MenuConfig, 'userGroups'>]?: boolean;
    };
};

type GetResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: MenuConfig[];
};

function get(data: GetRequestData) {
    return fetchWithTimeout('menu-config/get', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: GetResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type UpdateRequestData = MenuConfig & { menuConfigId: string };

type UpdateResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: MenuConfig;
};

function update(data: UpdateRequestData) {
    return fetchWithTimeout('menu-config/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: UpdateResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type UpdateBulkResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: MenuConfig[];
};

function updateBulk(data: UpdateRequestData[]) {
    return fetchWithTimeout('menu-config/updateBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: UpdateBulkResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type RemoveRequestData = MenuConfig & { menuConfigId: string };

type RemoveResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: {};
};

function remove(data: RemoveRequestData) {
    return fetchWithTimeout('menu-config/remove', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: RemoveResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

function removeBulk(data: RemoveRequestData[]) {
    return fetchWithTimeout('menu-config/removeBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: RemoveResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

export default { create, createBulk, get, update, updateBulk, remove, removeBulk };
